export default "__VITE_ASSET__Bm9cNHmz__"